export default __webpack_public_path__ + "static/media/logo-full-home.6015a751.png";